import merge from "lodash/merge";
import { PopupExtension, UrlExtension } from "../extensions";
import { BasePluginsExtension, BaseSchemaExtension, } from "../extensions/base/extension";
import { BlockquoteExtension } from "../extensions/blockquote/extension";
import { BoldExtension } from "../extensions/bold/extension";
import { CodeExtension } from "../extensions/code/extension";
import { ColorExtension } from "../extensions/color/extension";
import { FormattingToolbarExtension } from "../extensions/formatting-toolbar/extension";
import { HeadingExtension } from "../extensions/heading/extension";
import { HighlightExtension } from "../extensions/highlight/extension";
import { ItalicExtension } from "../extensions/italic/extension";
import { ListExtension } from "../extensions/list/extension";
import { MaxLengthExtension } from "../extensions/max-length/extension";
import { PillExtension } from "../extensions/pill/extension";
import { PlaceholderExtension, } from "../extensions/placeholder";
import { SmallParagraphExtension } from "../extensions/small-paragraph/extension";
import { StrikethroughExtension } from "../extensions/strikethrough/extension";
import { UnderlineExtension } from "../extensions/underline/extension";
const defaultOptions = {
    maxLength: null,
    multiline: false,
    mode: "simple",
    placeholder: {
        placeholderMode: "empty-doc",
        placeholder: "Write here...",
    },
    dashboardsStyle: false,
    showToolbarButtonArrows: false,
    showToolbarButtonDividers: false,
    extraExtensions: [],
};
/**
 * Create a list of editor extensions, containing only the ones necessary for creating a simple text field with support to pill variables.
 */
export function createPillPickerExtensions(options = {}) {
    const { placeholder, maxLength, multiline, mode, dashboardsStyle = false, showToolbarButtonArrows = false, showToolbarButtonDividers = false, extraExtensions, } = merge({}, defaultOptions, options);
    const enableParagraphAlignment = mode === "richtext";
    return [
        multiline
            ? new BaseSchemaExtension({ enableParagraphAlignment })
            : new BaseSchemaExtension({
                docContent: "paragraph",
                hardBreak: false,
                enableParagraphAlignment,
            }),
        new PlaceholderExtension(placeholder),
        new BasePluginsExtension(),
        new PillExtension(),
        new MaxLengthExtension(maxLength),
        ...(mode === "slack"
            ? [
                new BoldExtension(),
                new ItalicExtension(),
                new StrikethroughExtension(),
                new CodeExtension(),
                new BlockquoteExtension(),
                new ListExtension(),
                new FormattingToolbarExtension({ mode: "static" }),
                new UrlExtension(),
                new PopupExtension(),
            ]
            : []),
        ...(mode === "richtext"
            ? [
                new BoldExtension(),
                new ItalicExtension(),
                new UnderlineExtension(),
                new StrikethroughExtension(),
                new CodeExtension(),
                new SmallParagraphExtension(),
                new ColorExtension(),
                new HighlightExtension(),
                new BlockquoteExtension(),
                new ListExtension(),
                new HeadingExtension({ collapse: false, indent: false }),
                new FormattingToolbarExtension({
                    mode: "static",
                    dashboardsStyle,
                    showToolbarButtonArrows,
                    showToolbarButtonDividers,
                }),
                new UrlExtension(),
                new PopupExtension(),
            ]
            : []),
        ...(extraExtensions || []),
    ];
}
